import gsap from 'gsap';

import сustomPageScroll from '../components/custom-scroll';

import { CLASSES } from '../helpers/consts';
import scrollTo from '../helpers/scrollTo';
import refreshScrollAndTriggers from '../helpers/refreshScrollTriggers';

export default () => {
	const sections = document.querySelectorAll('.js-info-section');
	sections.forEach((section) => {
		const btn = section.querySelector('.js-info-section-more-btn');
		const block = section.querySelector('.js-info-section-more-text');

		if (!btn || !block) {
			return
		}

		btn.addEventListener('click', (e) => {
			e.preventDefault();
			const isOpen = section.classList.contains(CLASSES.open);

			if(isOpen) {
				section.classList.remove(CLASSES.open);

				gsap.to(block, {
					height: 0,
					duration: 0.5,
					onComplete: () => {
						setTimeout(() => {
							const rect = section.getBoundingClientRect();
							scrollTo(0, сustomPageScroll.scrollY + rect.top, 700);
							refreshScrollAndTriggers();
						});
					}
				});

			} else {
				section.classList.add(CLASSES.open);

				gsap.to(block, {
					height: 'auto',
					duration: 0.5,
					onComplete: () => {
						refreshScrollAndTriggers();
					}
				});
			}
		});

	})
}
